import {Component, OnInit} from '@angular/core';
import {Grid} from '../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../shared/Models/columns';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../shared/Services/broadcast.service';
import {Router} from '@angular/router';
import {DisclaimerService} from '../../Services/disclaimer.service';

@Component({
  selector: 'app-packaging-label',
  templateUrl: './disclaimer-overview.component.html',
  styleUrls: ['./disclaimer-overview.component.scss']
})

export class DisclaimerOverviewComponent implements OnInit {

  public grid: Grid;
  public specialButtons = [];

  constructor(
    private disclaimerService: DisclaimerService,
    private broadcastService: BroadcastService,
    private router: Router,
    private translator: TranslateService,
  ) { }

  ngOnInit() {
    this.specialButtons.push({
      btnIcon: 'fa fa-plus',
      btnName: this.translator.instant('global.add'),
      btnUrl: '',
      method: 'newDisclaimer',
      btnCustomClass: 'btn btn-primary ripple'
    });
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.disclaimer.content',
          prop: 'content',
          sortable: false,
          type: TextColumn.type,
          translate: false,
          isHtml: true,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          maxWidth: 60,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: (row) => {
                if (row.id) {
                  this.disclaimerService.removeDisclaimer(row.id).subscribe(() => {
                    this.refreshGrid(true);
                  });
                }
              },
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-edit fa-lg',
              tooltip: 'global.edit',
              onclick: (row) => {
                if (row.id) {
                  this.router.navigateByUrl('/back-office/disclaimer/' + row.id + '/edit');
                }
              },
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.disclaimerService,
      rememberURL: this.router.url,
      method: 'getDisclaimerBackoffice',
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      simpleSearch: false,
    };
  }

  callFunction(method) {
    this[method]();
  }

  newDisclaimer() {
    this.router.navigateByUrl('/back-office/disclaimer/manage');
  }
  refreshGrid(event) {
    if (event) {
      this.broadcastService.broadcast('refreshGrid', 'getDisclaimerBackoffice');
    }
  }
}
